// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"96df0ed9","787":"7287224c"}[chunkId] + ".chunk.js";
};